exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-overlay{\r\n    position:fixed;\r\n    background: rgba(0,0,0,0.8);\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0px;\r\n    z-index: 100;\r\n    left: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main